import { v4 } from "uuid";
import React, { useContext } from "react";
export const TasksContext = React.createContext();

export const useTasks = () => {
  const [tasks, setTasks] = useContext(TasksContext);

  return {
    get todaysDate() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;
      return dateString;
    },

    get tasks() {
      return tasks;
    },

    get completedTasks() {
      return tasks.filter((task) => task.complete === true);
    },

    get todaysTasks() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;
      return tasks.filter((task) => task.pushed <= dateString);
    },

    get tomorrowsTasks() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;
      return tasks.filter((task) => task.pushed > dateString);
    },

    addTask(taskText) {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;

      setTasks([
        ...tasks.filter((task) => task.pushed <= dateString),
        {
          id: v4(),
          text: taskText,
          complete: false,
          created: dateString,
          pushed: dateString,
        },
        ...tasks.filter((task) => task.pushed > dateString),
      ]);
    },

    markComplete(id) {
      setTasks([
        ...tasks.map((task) =>
          task.id !== id
            ? task
            : {
                ...task,
                complete: true,
              }
        ),
      ]);
    },

    markNotComplete(id) {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;

      setTasks([
        ...tasks.map((task) =>
          task.id !== id
            ? task
            : {
                ...task,
                complete: false,
                created: dateString,
              }
        ),
      ]);
    },

    pushToTomorrow(id) {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const dd = String(tomorrow.getDate()).padStart(2, "0");
      const mm = String(tomorrow.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = tomorrow.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;

      setTasks((tasks) => [
        ...tasks.filter((task) => task.id !== id),
        ...tasks
          .filter((task) => task.id === id)
          .map((task) =>
            task.id !== id
              ? task
              : {
                  ...task,
                  pushed: dateString,
                }
          ),
      ]);
    },

    pullToToday(id) {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = today.getFullYear();
      const dateString = yyyy + "/" + mm + "/" + dd;

      setTasks((tasks) => [
        ...tasks.filter((task) => task.pushed <= dateString),
        ...tasks
          .filter((task) => task.id === id)
          .map((task) =>
            task.id !== id
              ? task
              : {
                  ...task,
                  pushed: dateString,
                }
          ),
        ...tasks.filter((task) => task.pushed > dateString && task.id !== id),
      ]);
    },

    deleteTask(id) {
      setTasks(tasks.filter((task) => task.id !== id));
    },
  };
};
